import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import WhatsAppFloat from "@/components/WhatsAppFloat";
import { useLang } from "@/context/LanguageContext";

import { ArrowLeft, MapPin, Clock, Wind, CheckCircle, HelpCircle } from "lucide-react";
import Gallery from "@/components/GalleryPeru";

export default function Huacachina() {
  const { lang } = useLang();
  const isEn = lang === "en";

  useEffect(() => {
    window.scrollTo(0, 0);


/*
    // Page Title
    document.title = isEn 
      ? "Tandem Paragliding in Huacachina | Ica, Peru" 
      : "Vuelo Tándem en Parapente en Huacachina | Ica, Perú";
    
    // Meta Description Setup
    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement("meta");
      metaDescription.setAttribute("name", "description");
      document.head.appendChild(metaDescription);
    }
    metaDescription.setAttribute(
      "content", 
      isEn 
        ? "Book your tandem paragliding flight over the Huacachina Oasis in Ica, Peru. Experience flying over the giant desert dunes."
        : "Reserve su vuelo tándem en parapente sobre el Oasis de Huacachina en Ica, Perú. Viva la experiencia única de volar sobre las dunas del desierto."
    );
    */

   // lang deve ser 'en' | 'es' | 'pt'
// ex: const lang = isEn ? 'en' : isPt ? 'pt' : 'es';

// Page Title
document.title =
  lang === 'en'
    ? "Tandem Paragliding in Huacachina | Ica, Peru"
    : lang === 'pt'
    ? "Voo Tandem de Parapente em Huacachina | Ica, Peru"
    : "Vuelo Tándem en Parapente en Huacachina | Ica, Perú";

// Meta Description Setup
let metaDescription = document.querySelector('meta[name="description"]');
if (!metaDescription) {
  metaDescription = document.createElement("meta");
  metaDescription.setAttribute("name", "description");
  document.head.appendChild(metaDescription);
}
metaDescription.setAttribute(
  "content",
  lang === 'en'
    ? "Book your tandem paragliding flight over the Huacachina Oasis in Ica, Peru. Experience flying over the giant desert dunes. Whatsapp +51949373734"
    : lang === 'pt'
    ? "Reserve seu voo duplo de parapente sobre o Oásis de Huacachina em Ica, Peru. Viva a experiência única de voar sobre as dunas do deserto."
    : "Reserve su vuelo tándem en parapente sobre el Oasis de Huacachina en Ica, Perú. Viva la experiencia única de volar sobre las dunas del desierto."
);

let keywords="paragliding Peru, parapente Peru, parapente Ica, Huacachina paragliding, parapente Huacachina, oasis Huacachina, Huacachina oasis Peru, tandem paragliding Peru, vuelo en tandem parapente, voo duplo parapente, parapente en tandem Ica, parapente sobre el desierto, desert paragliding Peru, dunas de Huacachina, sandboarding Huacachina, aventura en el desierto, adventure tourism Peru, turismo de aventura Peru, turismo aventura Ica, paratrike Peru, paramotor Peru, trike parapente, handglide, vuelo sobre dunas, flying over sand dunes, voo sobre dunas de areia, parapente no deserto, parapente Ica Peru, Ica desert flight, vuelo panorámico Ica, vuelo turístico Huacachina, extreme sports Peru, deportes extremos Peru, esportes radicais Peru, outdoor adventure Peru, vacations Peru, vacaciones Peru, férias Peru, viagem ao Peru, viaje a Peru, trip to Peru, Nazca Ica tour, oasis en el desierto, oasis no deserto, parapente turismo, adrenaline Peru, adrenalina Peru, voo de parapente Peru, parapente extremo, vuelo extremo Ica, paragliding sand dunes South America, parapente América del Sur, parapente América do Sul";


// Meta Keywords Setup
let metaKeywords = document.querySelector('meta[name="keywords"]');
if (!metaKeywords) {
  metaKeywords = document.createElement("meta");
  metaKeywords.setAttribute("name", "keywords");
  document.head.appendChild(metaKeywords);
}
metaKeywords.setAttribute(
  "content",
  keywords
);


// Geo Meta Tags Setup
const geoTags = [
  { name: "geo.region", content: "PE-ICA" },
  { name: "geo.placename", content: "Huacachina, Ica, Perú" },
  { name: "geo.position", content: "-14.0872;-75.7625" },
  { name: "ICBM", content: "-14.0872, -75.7625" },
];

geoTags.forEach(({ name, content }) => {
  let tag = document.querySelector(`meta[name="${name}"]`);
  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute("name", name);
    document.head.appendChild(tag);
  }
  tag.setAttribute("content", content);
});

// Helper: cria ou atualiza uma meta tag (og:* usa "property", twitter:* usa "name")
function setMetaTag(attrType, attrValue, content) {
  let tag = document.querySelector(`meta[${attrType}="${attrValue}"]`);
  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute(attrType, attrValue);
    document.head.appendChild(tag);
  }
  tag.setAttribute("content", content);
  return tag;
}

// --- Open Graph / Facebook ---
setMetaTag("property", "og:type", "website");
setMetaTag("property", "og:site_name", "ParaglideTour");
setMetaTag("property", "og:url", "https://paraglidetour.com/peru"); // ajuste para a URL real

setMetaTag(
  "property",
  "og:title",
  lang === 'en'
    ? "Tandem Paragliding in Huacachina | Ica, Peru · Paraglide Tour"
    : lang === 'pt'
    ? "Voo Duplo de Parapente em Huacachina | Ica, Peru · Paraglide Tour"
    : "Vuelo Tándem en Parapente en Huacachina | Ica, Perú · Paraglide Tour"
);

setMetaTag(
  "property",
  "og:description",
  lang === 'en'
    ? "Book your tandem paragliding flight over the Huacachina Oasis in Ica, Peru. Experience flying over the giant desert dunes."
    : lang === 'pt'
    ? "Reserve seu voo duplo de parapente sobre o Oásis de Huacachina em Ica, Peru. Viva a experiência de voar sobre as dunas gigantes do deserto."
    : "Reserve su vuelo tándem en parapente sobre el Oasis de Huacachina en Ica, Perú. Viva la experiencia única de volar sobre las dunas del desierto."
);

setMetaTag("property", "og:image", "https://ik.imagekit.io/paraglidetour/huacachina_peru/tandem_paragliding_huacachina_peru8.jpg"); // trocar pela imagem real
setMetaTag("property", "og:image:width", "1200");
setMetaTag("property", "og:image:height", "630");
setMetaTag(
  "property",
  "og:image:alt",
  lang === 'en'
    ? "Tandem paragliding over Huacachina Oasis, Ica, Peru"
    : lang === 'pt'
    ? "Voo duplo de parapente sobre o Oásis de Huacachina, Ica, Peru"
    : "Vuelo tándem en parapente sobre el Oasis de Huacachina, Ica, Perú"
);

setMetaTag(
  "property",
  "og:locale","PE"
  //lang === 'en' ? "en_US" : lang === 'pt' ? "pt_BR" : "es"
);

// og:locale:alternate — tags repetidas, precisam de tratamento à parte
const alternateLocales =
  lang === 'en' ? ["es_PE", "pt_BR"] :
  lang === 'pt' ? ["en_US", "es_PE"] :
  ["en_US", "pt_BR"];

document.querySelectorAll('meta[property="og:locale:alternate"]').forEach(el => el.remove());
alternateLocales.forEach(locale => {
  const tag = document.createElement("meta");
  tag.setAttribute("property", "og:locale:alternate");
  tag.setAttribute("content", locale);
  document.head.appendChild(tag);
});

// --- Twitter Card ---
setMetaTag("name", "twitter:card", "summary_large_image");
setMetaTag("name", "twitter:site", "@paraglidetour");
setMetaTag("name", "twitter:creator", "@paraglidetour");

setMetaTag(
  "name",
  "twitter:title",
  lang === 'en'
    ? "Tandem Paragliding in Huacachina | Ica, Peru · Paraglide Tour"
    : lang === 'pt'
    ? "Voo duplo de Parapente em Huacachina | Ica, Peru · Paraglide Tour"
    : "Vuelo Tándem en Parapente en Huacachina | Ica, Perú · Paraglide Tour"
);

setMetaTag(
  "name",
  "twitter:description",
  lang === 'en'
    ? "Book your tandem paragliding flight over the Huacachina Oasis in Ica, Peru. Zero experience required."
    : lang === 'pt'
    ? "Reserve seu voo duplo de parapente sobre o Oásis de Huacachina em Ica, Peru. Não é necessária experiência."
    : "Reserve su vuelo tándem en parapente sobre el Oasis de Huacachina en Ica, Perú. No se requiere experiencia."
);

setMetaTag("name", "twitter:image", "https://ik.imagekit.io/paraglidetour/huacachina_peru/tandem_paragliding_huacachina_peru8.jpg"); // mesma imagem do og:image
setMetaTag(
  "name",
  "twitter:image:alt",
  lang === 'en'
    ? "Tandem paragliding over Huacachina Oasis, Ica, Peru"
    : lang === 'pt'
    ? "Voo duplo de parapente sobre o Oásis de Huacachina, Ica, Peru"
    : "Vuelo tándem en parapente sobre el Oasis de Huacachina, Ica, Perú"
);



    // Remove any previous JSON-LD schema to ensure only the current one stays
    document.querySelectorAll('script[type="application/ld+json"]').forEach(script => {
      script.remove();
    });

    // SEO Schema Setup (JSON-LD) for Parapente Huacachina
    const schemaData = {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "LocalBusiness",
          "@id": "huacachina",
          "name": "Parapente Huacachina - Tandem Paragliding in Ica, Peru",
          "telephone": "+51949373734",
          "url": "https://www.paraglidetour.com/huacachina",
          "image": "https://ik.imagekit.io/paraglidetour/huacachina_peru/tandem_paragliding_huacachina_peru1.jpg",
          "sameAs": [
            "https://www.instagram.com/parapentehuacachina/",
            "https://www.tiktok.com/@parapentehuacachina"
          ],
          "priceRange": "$120.00",
          "address": {
            "@type": "PostalAddress",
            "addressLocality": "Huacachina, Ica",
            "addressRegion": "Ica",
            "addressCountry": "PE"
          }
        },
        {
          "@type": "Product",
          "name": isEn 
            ? "Tandem Paragliding Flight over Huacachina Oasis" 
            : "Vuelo Tándem en Parapente sobre el Oasis de Huacachina",
          "description": isEn 
            ? "Fly over the stunning desert dunes and the majestic Huacachina Oasis in Ica. An incredible tour with spectacular views."
            : "Vuele sobre las impresionantes dunas del desierto y el majestuoso Oasis de la Huacachina en Ica. Un tour increíble con vistas espectaculares.",
          "url": "https://paraglidetour.com/tours/huacachina_peru",
          "image": "https://ik.imagekit.io/paraglidetour/huacachina_peru/tandem_paragliding_huacachina_peru8.jpg",
          "brand": "Parapente Huacachina",
          "sku":"PARAPENTE_HUACACHINA",
          "provider": {
            "@id": "huacachina",
            "name": "Parapente Huacachina",
            "sameAs": "https://www.paraglidetour.com/huacachina"
          },
          "offers": {
            "@type": "Offer",
            "priceCurrency": "USD",
            "price": "120.00",
            "availability": "https://schema.org/InStock",
            "url": "https://paraglidetour.com/tandem/huacachina_desert",
            "availability": "https://schema.org/InStock",
            "validFrom": "2026-01-01T08:00:00+00:00",
            "priceValidUntil": "2026-12-30T23:59:59+00:00",
            "priceSpecification": {
              "@type": "UnitPriceSpecification",
              "priceType": "https://schema.org/StrikethroughPrice",
              "price": "150.00",
              "priceCurrency":  "USD"
            },
          }
        },
        {
          "@type": "FAQPage",
          "mainEntity": [
             {
                "@type": "Question",
                "name": isEn ? "Do I need previous experience to fly in Huacachina?" : "¿Requiero experiencia previa para volar en Huacachina?",
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text": isEn 
                      ? "No previous experience is required. You will fly with a certified instructor pilot who handles all paraglider operations."
                      : "No se requiere ninguna experiencia previa. Irá acompañado por un piloto instructor certificado que se encarga de todo el manejo del parapente."
                }
             },
             {
                "@type": "Question",
                "name": isEn ? "Is there a weight limit for passengers?" : "¿Existe un límite de peso para el pasajero?",
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text": isEn 
                      ? "The maximum weight allowed is 110 kg (242 lbs) for technical and safety reasons on dune takeoffs."
                      : "El peso máximo permitido es de 110 kg (242 lbs) por razones técnicas y de seguridad en el despegue en dunas."
                }
             },
             {
                "@type": "Question",
                "name": isEn ? "How long does the flight experience take?" : "¿Cuánto tiempo dura la experiencia?",
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text": isEn 
                      ? "Flight time is approximately 15 to 20 minutes, depending on desert thermal wind conditions."
                      : "El tiempo de vuelo es de aproximadamente 15 a 20 minutos, dependiendo de las condiciones del viento térmico en el desierto."
                }
             },
             {
                "@type": "Question",
                "name": isEn ? "What happens if the weather is not suitable?" : "¿Qué sucede si el clima no es adecuado?",
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text": isEn 
                      ? "Safety is our top priority. If wind conditions don't meet safety parameters, the activity will be rescheduled or fully refunded."
                      : "La seguridad es la prioridad. Si el viento no cumple los parámetros de seguridad, la actividad se reprograma o se efectúa el reembolso total de la reserva."
                }
             },
             {
                "@type": "Question",
                "name": isEn ? "Are photos and videos included?" : "¿El tour incluye fotos y video?",
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text": isEn 
                      ? "Yes, the tour includes an HD photo and video package taken with a GoPro camera to capture your memories over the oasis."
                      : "Sí, el tour incluye un paquete de fotos y videos tomados con cámara HD (GoPro) para guardar el recuerdo del vuelo sobre el oasis."
                }
             }
          ]
        }
      ]
    };

    const scriptSchema = document.createElement('script');
    scriptSchema.setAttribute('id', 'seo-schema');
    scriptSchema.setAttribute('type', 'application/ld+json');
    scriptSchema.textContent = JSON.stringify(schemaData);
    document.head.appendChild(scriptSchema);

    return () => {
      if (scriptSchema && scriptSchema.parentNode) {
        scriptSchema.parentNode.removeChild(scriptSchema);
      }
    };
  }, [isEn,lang]);

  const faqData = [
    {
      q: isEn ? "Do I need previous experience to fly in Huacachina?" : "¿Requiero experiencia previa para volar en Huacachina?",
      a: isEn 
        ? "No previous experience is required. You will fly with a certified instructor pilot who handles all paraglider operations."
        : "No se requiere ninguna experiencia previa. Irá acompañado por un piloto instructor certificado que se encarga de todo el manejo del parapente."
    },
    {
      q: isEn ? "Is there a weight limit for passengers?" : "¿Existe un límite de peso para el pasajero?",
      a: isEn 
        ? "The maximum weight allowed is 110 kg (242 lbs) for technical and safety reasons on dune takeoffs."
        : "El peso máximo permitido es de 110 kg (242 lbs) por razones técnicas y de seguridad en el despegue en dunas."
    },
    {
      q: isEn ? "How long does the flight experience take?" : "¿Cuánto tiempo dura la experiencia?",
      a: isEn 
        ? "Flight time is approximately 15 to 20 minutes, depending on desert thermal wind conditions."
        : "El tiempo de vuelo es de aproximadamente 15 a 20 minutos, dependiendo de las condiciones del viento térmico en el desierto."
    },
    {
      q: isEn ? "What happens if the weather is not suitable?" : "¿Qué sucede si el clima no es adecuado?",
      a: isEn 
        ? "Safety is our top priority. If wind conditions don't meet safety parameters, the activity will be rescheduled or fully refunded."
        : "La seguridad es la prioridad. Si el viento no cumple los parámetros de seguridad, la actividad se reprograma o se efectúa el reembolso total de la reserva."
    },
    {
      q: isEn ? "Are photos and videos included?" : "¿El tour incluye fotos y video?",
      a: isEn 
        ? "Yes, the tour includes an HD photo and video package taken with a GoPro camera to capture your memories over the oasis."
        : "Sí, el tour incluye un paquete de fotos y videos tomados con cámara HD (GoPro) para guardar el recuerdo del vuelo sobre el oasis."
    }
  ];

  return (
    <div className="min-h-screen bg-sand text-jungle ">
      <Header />

      {/* SEO Intro Section with Background Image */}
      <section 
        className="pt-20 pb-16 relative bg-cover bg-center border-b border-jungle/10"
        style={{ backgroundImage: `url('https://ik.imagekit.io/paraglidetour/the_best_paragliding_tour/tandem_paragliding_huacachina_peru.webp')` }}
      >
        <div className="absolute inset-0 bg-white/0 backdrop-blur-[0px]"></div>

        <div className="max-w-2xl mx-auto px-6 md:px-12 text-center relative z-10">
          <Link
            to="/"
            className="inline-flex items-center gap-2 font-overline text-[10px] text-white hover:text-zinc-700 transition-colors mb-6 font-semibold uppercase tracking-wider"
          >
            <ArrowLeft size={14} /> {isEn ? "BACK TO HOMEPAGE" : "VOLVER A LA PÁGINA PRINCIPAL"}
          </Link>
          <div className="font-overline text-white text-xs mb-3 font-bold tracking-wider">
            {isEn ? "Adventure in Peru" : "Aventura en Perú"}
          </div>
          
          <h1 className="font-display text-4xl md:text-5xl text-white font-bold leading-tight mb-6">
            {isEn ? "Tandem Paragliding in Huacachina" : "Parapente Tándem en Huacachina"}
          </h1>
          <p className="text-white text-base md:text-lg max-w-3xl mx-auto leading-relaxed font-medium">
            {isEn ? (
              <>
                Discover the thrill of <strong>paragliding in Peru</strong>. Our tandem flight experience is perfect for enjoying breath-taking aerial views of the <strong>Huacachina Oasis</strong> and the desert of <strong>Ica</strong>. Feel the freedom of soaring over South America's most iconic dunes!
              </>
            ) : (
              <>
                Descubra la emoción de <strong>volar en parapente en Perú</strong>. Nuestra experiencia de vuelo tándem es perfecta para disfrutar de panorámicas impresionantes del <strong>Oasis de Huacachina</strong> y el desierto de <strong>Ica</strong>. ¡Sienta la libertad de sobrevolar las dunas más majestuosas de Sudamérica!
              </>
            )}
          </p>
        </div>
      </section>

      {/* Flight Package Section (Single Tour Option) */}
      <section className="pt-16 md:pt-24 pb-16 bg-sand">
        <div className="max-w-3xl mx-auto px-6 md:px-12">
          <div className="text-center mb-12">
            <h2 className="font-display text-3xl md:text-4xl text-jungle mb-4">
              {isEn ? "Desert Paragliding Tour" : "Tour de Parapente en el Desierto"}
            </h2>
            <p className="text-forest text-lg">
              {isEn 
                ? "Take off from the giant sand dunes for an unforgettable flight over the Huacachina Oasis." 
                : "Despegue desde las dunas para disfrutar de un sobrevuelo inolvidable sobre el Oasis de Huacachina."}
            </p>
          </div>

          <div className="grid grid-cols-1">
            {/* Single Tour Option */}
            <article className="bg-white rounded-2xl border border-jungle/15 shadow-sm hover:shadow-lg transition-shadow relative overflow-hidden flex flex-col">
              <div className="absolute top-0 right-0 bg-terracotta text-white font-overline text-[10px] px-3 py-1 rounded-bl-lg z-10 uppercase font-bold">
                {isEn ? "FEATURED TOUR" : "TOUR DESTACADO"}
              </div>
              <img 
                src="https://ik.imagekit.io/paraglidetour/huacachina_peru/tandem_paragliding_huacachina_peru8.jpg" 
                alt={isEn ? "Paragliding flight over Huacachina" : "Vuelo en Parapente sobre Huacachina"}
                title={isEn ? "Paragliding flight over Huacachina" : "Vuelo en Parapente sobre Huacachina"}  
                className="w-full h-64 md:h-80 object-cover"
              />
              <div className="p-6 md:p-8 flex flex-col flex-grow">
                <div className="flex items-center gap-3 mb-4 text-terracotta">
                  <MapPin size={24} />
                  <h3 className="font-display text-2xl text-jungle">
                    {isEn ? "Huacachina Tandem Flight" : "Vuelo Tándem Huacachina"}
                  </h3>
                </div>
                <p className="text-forest mb-6 flex-grow">
                  {isEn ? (
                    "An unparalleled paragliding flight over the famous Huacachina Oasis and the massive sand dunes of Ica. Accompanied at all times by a certified professional pilot."
                  ) : (
                    "Un vuelo sin igual sobrevolando el Oasis de Huacachina y las inmensas dunas de Ica. Guiado en todo momento por un piloto profesional en vuelo bipersonal."
                  )}
                </p>
                
                <ul className="space-y-3 mb-8">
                  <li className="flex items-center gap-2 text-forest">
                    <Clock size={18} className="text-terracotta" />
                    <span>{isEn ? "Flight duration:" : "Duración del vuelo:"} <strong>5 {isEn ? "to" : "a"} 15 {isEn ? "minutes" : "minutos"}</strong></span>
                  </li>
                  <li className="flex items-center gap-2 text-forest">
                    <Wind size={18} className="text-terracotta" />
                    <span>{isEn ? "Thermal & dynamic desert soaring" : "Vuelo térmico y dinámico en desierto"}</span>
                  </li>
                  <li className="flex items-center gap-2 text-forest">
                    <CheckCircle size={18} className="text-jungle" />
                    <span>{isEn ? "HD GoPro Photos and Videos included" : "Fotos y Videos en HD con GoPro incluidos"}</span>
                  </li>
                  <li className="flex items-center gap-2 text-forest">
                    <CheckCircle size={18} className="text-jungle" />
                    <span>{isEn ? "Full safety gear & pre-flight briefing" : "Equipo completo e instrucción pre-vuelo"}</span>
                  </li>
                </ul>

                <div className="flex flex-col gap-2 items-start">
                                      <Link to="/tandem/huacachina_desert" data-testid="package-details-btn-huacachina_desert" className="btn-primary text-center justify-center font-overline text-[20px] text-center justify-center text-terracotta hover:text-forest transition-colors">
                                        Details →
                                      </Link>
                                     
                              </div>

                <div className="border-t border-jungle/10 pt-6 mt-auto">
                  <div className="flex flex-col mb-4">
                    <span className="line-through text-forest/70 text-sm font-medium">{isEn ? "Was $150.00" : "Antes $170.00"}</span>
                    <span className="font-display text-4xl text-jungle">$120<span className="text-xl">.00</span></span>
                  </div>
                  <a href="https://wa.me/51949373734" id="link_huacachina" className="btn-primary w-full text-center justify-center">
                    {isEn ? "Book Huacachina Flight" : "Reservar Vuelo Huacachina"}
                     <img 
                      src="https://ik.imagekit.io/paraglidetour/whatsapp-50683455135-parapente-puravida.svg" 
                      alt="WhatsApp Icon"
                      className="inline-block ml-2 w-5 h-5"
                    ></img>
                  </a>
                </div>
              </div>
            </article>

           

          </div>
        </div>
      </section>
      <Gallery lang={lang} location="huacachina" />


              <div className="max-w-9xl mx-auto px-6 md:px-12">
          <div className="text-center mb-12">

                              <h3 className="font-display text-6xl md:text-6xl text-jungle mb-4">

                    {isEn?(<>Tandem Paragliding Over the Huacachina Oasis – Ica, Peru</>):(<>Vuelo en Parapente Tándem sobre el Oasis de Huacachina – Ica, Perú</>)}
                    </h3>
               <p className="text-black text-base md:text-lg max-w-6xl mx-auto leading-relaxed font-medium">
            {isEn ? (
              <>
                Imagine soaring above one of the most surreal landscapes on Earth: the Huacachina oasis, a shimmering emerald lagoon surrounded by towering golden sand dunes in the heart of the Peruvian desert. Our tandem paragliding flight in Ica offers you the rare chance to experience this natural wonder from a perspective only a handful of travelers ever get to see — floating silently in the sky, wind in your face, with the endless dunes of Ica stretching to the horizon in every direction.
              </>
            ) : (
              <>
                Imagina volar sobre uno de los paisajes más surrealistas del planeta: el oasis de Huacachina, una laguna color esmeralda rodeada de imponentes dunas doradas en pleno corazón del desierto peruano. Nuestro vuelo en parapente tándem en Ica te ofrece la oportunidad única de vivir esta maravilla natural desde una perspectiva que muy pocos viajeros llegan a experimentar: flotando en silencio por el cielo, con el viento en el rostro y las interminables dunas de Ica extendiéndose hasta el horizonte.
              </>
            )}
          </p>




            <p className="text-black text-base md:text-lg max-w-6xl mx-auto leading-relaxed font-medium">
            {isEn ? (
              <>
Flying tandem means you don't need any previous paragliding experience. You'll be securely harnessed alongside a certified, professional pilot with years of flying experience over the Huacachina desert and coastal thermals of Peru. From takeoff to landing, safety is our top priority, using internationally certified equipment and rigorously trained instructors so you can relax and fully enjoy the adventure of a lifetime.              </>
            ) : (
              <>
Volar en tándem significa que no necesitas experiencia previa en parapente. Estarás asegurado junto a un piloto profesional certificado, con años de experiencia volando sobre el desierto de Huacachina y las térmicas costeras del Perú. Desde el despegue hasta el aterrizaje, la seguridad es nuestra prioridad número uno, utilizando equipo certificado internacionalmente e instructores rigurosamente capacitados, para que puedas relajarte y disfrutar al máximo de esta aventura inolvidable.              </>
            )}
          </p>


            <p className="text-black text-base md:text-lg max-w-6xl mx-auto leading-relaxed font-medium">
            {isEn ? (
              <>
As you glide over Huacachina, you'll see the oasis palm trees, the sand-boarding dunes, and the small desert town below shrink into a postcard-perfect scene. Depending on wind and thermal conditions, flights can last several minutes, giving you time to take in panoramic views of Ica's desert, distant vineyards, and — on clear days — glimpses toward the Pacific coastline. It's the perfect complement to a sandboarding or dune-buggy tour, adding an unforgettable aerial dimension to your Huacachina adventure.              </>
            ) : (
              <>
Mientras planeas sobre Huacachina, verás las palmeras del oasis, las dunas de sandboarding y el pequeño pueblo desértico convertirse en una postal perfecta debajo de ti. Dependiendo de las condiciones de viento y térmicas, los vuelos pueden durar varios minutos, dándote tiempo para apreciar vistas panorámicas del desierto de Ica, viñedos distantes y, en días despejados, incluso el litoral del Pacífico. Es el complemento perfecto para un tour de sandboarding o de buggies por las dunas, sumando una dimensión aérea inolvidable a tu aventura en Huacachina.              </>
            )}
          </p>


             <p className="text-black text-base md:text-lg max-w-6xl mx-auto leading-relaxed font-medium">
            {isEn ? (
              <>
Whether you're an adrenaline seeker looking for extreme sports in Peru, a photographer chasing the perfect desert shot, or simply someone wanting a once-in-a-lifetime experience, tandem paragliding over Huacachina is one of the top adventure activities in Ica and all of Peru. Book your flight with paraglidetour.com/peru and discover why paragliding over the Huacachina desert oasis has become a must-do adventure for travelers visiting Peru.              </>
            ) : (
              <>
Ya seas un amante de la adrenalina en busca de deportes extremos en Perú, un fotógrafo persiguiendo la toma perfecta del desierto, o simplemente alguien que busca vivir una experiencia única en la vida, el vuelo en parapente tándem sobre Huacachina es una de las mejores actividades de aventura en Ica y en todo el Perú. Reserva tu vuelo en paraglidetour.com/peru y descubre por qué volar en parapente sobre el oasis del desierto de Huacachina se ha convertido en una aventura imprescindible para quienes visitan Perú.              </>
            )}
          </p>

          </div></div>



      {/* FAQ Visual Section */}
      <section className="pb-20 bg-sand border-t border-jungle/10 pt-16">
        <div className="max-w-4xl mx-auto px-6 md:px-12">
          <div className="text-center mb-12">
            <h2 className="font-display text-3xl text-jungle mb-3">
              {isEn ? "Frequently Asked Questions" : "Preguntas Frecuentes"}
            </h2>
            <p className="text-forest">
              {isEn ? "Everything you need to know before taking off" : "Todo lo que necesita saber antes de despegar"}
            </p>
          </div>

          <div className="space-y-6">
            {faqData.map((faq, index) => (
              <div key={index} className="bg-white rounded-xl p-6 border border-jungle/10 shadow-sm">
                <h3 className="font-display text-lg text-jungle font-semibold mb-2 flex items-center gap-2">
                  <HelpCircle size={18} className="text-terracotta shrink-0" />
                  {faq.q}
                </h3>
                <p className="text-forest text-sm leading-relaxed pl-6">
                  {faq.a}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>


      <Footer />

      <WhatsAppFloat />
    </div>
  );
}
